import { render, staticRenderFns } from "./StatusSidebar.vue?vue&type=template&id=51e2252c&scoped=true"
import script from "./StatusSidebar.vue?vue&type=script&lang=js"
export * from "./StatusSidebar.vue?vue&type=script&lang=js"
import style0 from "./StatusSidebar.vue?vue&type=style&index=0&id=51e2252c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2252c",
  null
  
)

export default component.exports